export const arrayUnique = <T>(arr: T[], equal: (a: T, b: T) => boolean) =>
  arr.filter((value, index, self) => index === self.findIndex((t) => equal(t, value)));
